class OEmbedExporter {

    /**
     * @param {object} oembed
     */
    constructor(oembed) {
        this._oembed = oembed
    }

    /**
     * Provider property might differ depending on oEmbed implementation
     *
     * @returns {*}
     */
    get provider() {
        return this._oembed.provider_name || this._oembed.provider
    }

    /**
     * Author property might differ depending on oEmbed implementation
     *
     * @returns {*}
     */
    get author() {
        return this._oembed.author_name || this._oembed.author
    }

    /**
     * Gets title using template string
     *
     * @param titleTemplate
     */
    getTitle(titleTemplate) {
        const {author_url, title, provider_url} = this._oembed

        return titleTemplate.replace('{author_name}', this.author)
            .replace('{author_url}', author_url)
            .replace('{provider_name}', this.provider)
            .replace('{provider_url}', provider_url)
            .replace('{text}', title ? title : '')
    }

    /**
     * @param {...object} contexts
     * @returns {*}
     */
    getContext(...contexts) {
        if (!this.provider) {
            return null
        }

        const mappedContexts = contexts.map(this._mapContexts)
        const provider = this.provider.toLowerCase()

        for(let contexts of mappedContexts) {
            const foundContext = contexts.find((context) => context.provider === provider)

            if (foundContext) {
                return foundContext
            }
        }

        return null
    }

    /**
     * @param contextsObject
     * @returns {Array}
     * @private
     */
    _mapContexts(contextsObject) {
        return Object.keys(contextsObject).reduce((arr, context) => {
            arr.push(...contextsObject[context].map((provider) => {
                return {
                    context,
                    provider
                }
            }))
            return arr
        }, [])
    }
}

export {OEmbedExporter}
